import * as TK from 'components/site/NavigationTabs/translations/constants';
import { Translations } from 'translations/types';

export const navigationTabsEnUsLocale: Translations = {
  [TK.NAVIGATION_TABS_ALL_POSTS]: 'All Posts',
  [TK.NAVIGATION_TABS_ABOUT_SITE]: 'About The Site',
  [TK.NAVIGATION_TABS_EXTERNAL_LINKS]: 'External Links',
  [TK.NAVIGATION_TABS_INVISIBLE_POSTS]: 'Invisible Posts',
};
